<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .question -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('questions.question')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="question"
                  vid="question"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.question"
                    type="text"
                    :placeholder="$t('questions.question')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .grade --> </b-col
            ><b-col lg="3">
              <b-form-group
                id="input-group-2"
                :label="$t('questions.grade')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="grade"
                  vid="grade"
                  rules="required"
                >
                  <b-form-input
                    id="input-2"
                    v-model="newItem.grade"
                    type="number"
                    :placeholder="$t('questions.grade')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .worthy --> </b-col
            ><b-col lg="3">
              <b-form-group
                id="input-group-3"
                :label="$t('questions.worthy')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="worthy"
                  vid="worthy"
                  rules="required"
                >
                  <b-form-input
                    id="input-3"
                    v-model="newItem.worthy"
                    type="number"
                    :placeholder="$t('questions.worthy')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .type --> </b-col
            ><b-col lg="6">
              <div class="demo-inline-spacing">
                <b-form-radio
                  v-model="newItem.type"
                  name="some-radios"
                  value="multi_choose"
                >
                  {{ $t("questions.multi_choose") }}
                </b-form-radio>
                <b-form-radio
                  v-model="newItem.type"
                  name="some-radios"
                  value="true_or_false"
                >
                  {{ $t("questions.true_or_false") }}
                </b-form-radio>
                <b-form-radio
                  v-model="newItem.type"
                  name="some-radios"
                  value="connecting"
                >
                  {{ $t("questions.connecting") }}
                </b-form-radio>
                <b-form-radio
                  v-model="newItem.type"
                  name="some-radios"
                  value="drag_and_drop"
                >
                  {{ $t("questions.drag_and_drop") }}
                </b-form-radio>
                <b-form-radio
                  v-model="newItem.type"
                  name="some-radios"
                  value="missing_words"
                >
                  {{ $t("questions.missing_words") }}
                </b-form-radio>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row
            v-if="
              newItem.type == 'multi_choose' || newItem.type == 'true_or_false'
            "
          >
            <b-col lg="12">
              <b-form>
                <b-row>
                  <b-col lg="10">
                    <b-form-input
                      id="input-1"
                      v-model="newAnswer"
                      type="text"
                      :placeholder="$t('questions.answer')"
                    />
                  </b-col>
                  <b-col lg="2"
                    ><b-btn
                      block
                      variant="success"
                      type="button"
                      @click="addAnswer()"
                      :disabled="newAnswer.trim().length == 0"
                      >{{ $t("site.add") }}</b-btn
                    >
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
            <b-col lg="12">
              <br />
              <b-list-group>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-for="(answer, index) in newItem.answers"
                  :key="index"
                >
                  <span>{{ answer.answer }}</span>

                  <b-form-radio
                    v-model="answer.type"
                    name="answer"
                    value="1"
                    class="custom-control-success"
                  >
                    الإجابة الصحيحة
                  </b-form-radio>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <b-row
            v-if="
              newItem.type == 'drag_and_drop' || newItem.type == 'connecting'
            "
          >
            <b-col lg="12">
              <b-form>
                <b-row>
                  <b-col lg="5">
                    <b-form-input
                      id="input-1"
                      v-model="newAnswer"
                      type="text"
                      :placeholder="$t('questions.answer')"
                    />
                  </b-col>
                  <b-col lg="5">
                    <b-form-input
                      id="input-1"
                      v-model="remaining"
                      type="text"
                      :placeholder="$t('questions.remaining')"
                    />
                  </b-col>
                  <b-col lg="2"
                    ><b-btn
                      block
                      variant="success"
                      type="button"
                      @click="addAnswer()"
                      :disabled="newAnswer.trim().length == 0"
                      >{{ $t("site.add") }}</b-btn
                    >
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
            <b-col lg="12">
              <br />
              <b-list-group>
                <b-list-group-item
                  class="d-flex align-items-center"
                  v-for="(answer, index) in newItem.answers"
                  :key="index"
                >
                  <span>{{ answer.answer }}</span>
                  /
                  <span>{{ answer.remaining }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                 :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";
import Controller from "../../../../Controllers/QuestionsController";
import config from "../../../../config/config";

export default {
  name: "QuestionsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      course: [],
      newAnswer: "",
      remaining: "",
    };
  },

  created() {
    // this.newItem.type='multi_choose';
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.course_id= this.$route.params.courseId;
      let ret = new Controller().From(this.newItem);
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
        this.newItem={};
      }
    },
    addAnswer() {

      if (!this.newItem.answers) this.$set(this.newItem, "answers", []);
      if (this.newItem.type == "drag_and_drop" || this.newItem.type == "connecting")
        this.newItem.answers.push({
          answer: this.newAnswer.trim(),
          remaining: this.remaining.trim(),
          type: 0,
        });
      else
        this.newItem.answers.push({
          answer: this.newAnswer.trim(),
          type: 0,
        });

      this.newAnswer = "";
    },
  },
};
</script>
